/**
 * Configure the pdfjs-dist worker to resolve from the bundled node_modules
 * copy via `new URL(..., import.meta.url)` — same-origin, resolved by the
 * bundler at build time, no CDN dependency (issue #11100).
 *
 * The interim `@react-pdf-viewer/*` stack pinned `pdfjs-dist` at 3.4.120 and
 * loaded its worker from `unpkg.com` because its peer range
 * (`^2.16.105 || ^3.0.279`) blocked the 4.2.67+ fix for CVE-2024-4367
 * (GHSA-wgrm-67xf-hhpq). `react-pdf` tracks current pdfjs
 * releases, so the worker can now be same-origin instead.
 *
 * `new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url)` is
 * `react-pdf`'s own documented pattern — both webpack and Turbopack
 * statically resolve this to an emitted asset URL. Call sites must import
 * this only from code that is guaranteed client-only (a `next/dynamic`
 * loader with `ssr: false`, or a module already gated behind one) — pdfjs
 * relies on browser APIs that don't exist during SSR.
 */
export function pdfWorkerSrc(): string {
  return new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url
  ).toString();
}
